import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button/Button';
import Backdrop from 'components/Modal/Backdrop';
import { BUTTON_VARIANT } from 'constants/interfaces';

import ErrorList from './ErrorList';

import type IArchiveRestrictedModal from './interfaces/IArchiveRestrictedModal';

import styles from './sass/ArchiveRestrictedModal.module.scss';

function ArchiveRestrictedModal({ isOpen, onClose, archiveError }: IArchiveRestrictedModal) {
  const { t } = useTranslation();

  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  return isOpen ? createPortal(
    <Backdrop>
      <div
        className={styles.modalOverlay}
      >
        <div
          className={styles.modalContent}
        >
          <h2 id="modal-title" className={styles.modalTitle}>
            {t('common.archiveRestricted')}
          </h2>
          <div className={styles.modalBody}>
            <p>{t('common.archiveRestrictedDescription')}</p>
            <div className={styles.modalBodyList}>
              <ul>
                {archiveError?.data?.message?.length ? <ErrorList archiveError={archiveError} /> : null}
              </ul>
            </div>
            <p>{t('common.archiveRestrictedDescriptionBottom')}</p>
          </div>

          <div className={styles.modalFooter}>
            <Button
              title={t('common.cancel')}
              variant={BUTTON_VARIANT.cancel}
              onClick={onClose}
            />
          </div>

        </div>
      </div>
    </Backdrop>,
    document.body,
  ) : null;
}

export default ArchiveRestrictedModal;
